// extracted by mini-css-extract-plugin
export default {"chip":"Y7Pu5VTW9IyumgW5YrKS","label":"uOUBpQ2S0ARKZdxp2C3Q","pay_info_chip_span":"Pi9EDs3Q8RBYEOawHjvS","received_info_chip_span":"HKZNnyD2IqwXlb0GqNge"};